import { Form } from "devextreme-react";
import { GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../../../../redux/localization";
import { renderInformationItem } from "../detail";
import { AdminAccountLocation } from "./type";


export const AccountStorageDetail = forwardRef<any, { data: AdminAccountLocation }>((
    { data }, ref
) => {

    const localize = useSelector(getLocalized);

    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                dataField={"LocationTitle"}
                label={{
                    text: localize.getString("locationtitle")
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Country"}
                label={{
                    text: localize.getString("country")
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"City"}
                label={{
                    text: localize.getString("city")
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"District"}
                label={{
                    text: localize.getString("district")
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"SubDistrict"}
                label={{
                    text: localize.getString("subdistrict")
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Neighbourhood"}
                label={{
                    text: localize.getString("neighbourhood")
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"AddressDetail"}
                label={{
                    text: localize.getString("addressDetail")
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
        </GroupItem>
    </Form>
})  